var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsPhoneNumberWithLVS, MatchesWithLVS, TransformWithLVS } from '@goparrot/common';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsDate, IsEmail, IsNotEmpty, IsOptional, IsString, MaxDate, MaxLength } from 'class-validator';
import { DateTime } from 'luxon';
import { UserExposeGroup } from '../interface/user-expose-group';
import { USER_PROFILE_VALIDATION_PATTERN } from '../utils/ConstantUtils';
export class ReadUserProfileDto {
}
__decorate([
    ApiProperty({ maxLength: 50, example: 'Joe' }),
    IsOptional({ groups: [UserExposeGroup.PATCH, UserExposeGroup.SEARCH] }),
    IsString({ always: true }),
    IsNotEmpty({ always: true }),
    MaxLength(50, { always: true }),
    MatchesWithLVS(USER_PROFILE_VALIDATION_PATTERN, { always: true }),
    Expose({
        groups: [
            UserExposeGroup.MODEL,
            UserExposeGroup.READ,
            UserExposeGroup.CREATE,
            UserExposeGroup.PATCH,
            UserExposeGroup.SEARCH,
            UserExposeGroup.SEARCH_RESULT,
        ],
    }),
    __metadata("design:type", String)
], ReadUserProfileDto.prototype, "first_name", void 0);
__decorate([
    ApiProperty({ maxLength: 50, example: 'Doe' }),
    IsOptional({ groups: [UserExposeGroup.PATCH, UserExposeGroup.SEARCH] }),
    IsString({ always: true }),
    IsNotEmpty({ always: true }),
    MaxLength(50, { always: true }),
    MatchesWithLVS(USER_PROFILE_VALIDATION_PATTERN, { always: true }),
    Expose({
        groups: [
            UserExposeGroup.MODEL,
            UserExposeGroup.READ,
            UserExposeGroup.CREATE,
            UserExposeGroup.PATCH,
            UserExposeGroup.SEARCH,
            UserExposeGroup.SEARCH_RESULT,
        ],
    }),
    __metadata("design:type", String)
], ReadUserProfileDto.prototype, "last_name", void 0);
__decorate([
    ApiPropertyOptional({ format: 'email', maxLength: 100, example: 'mail@example.com' }),
    IsOptional({ always: true }),
    MaxLength(100, { always: true }),
    IsEmail(undefined, { groups: [UserExposeGroup.CREATE, UserExposeGroup.PATCH] }),
    Expose({
        groups: [
            UserExposeGroup.MODEL,
            UserExposeGroup.READ,
            UserExposeGroup.CREATE,
            UserExposeGroup.PATCH,
            UserExposeGroup.SEARCH,
            UserExposeGroup.SEARCH_RESULT,
        ],
    }),
    __metadata("design:type", String)
], ReadUserProfileDto.prototype, "email", void 0);
__decorate([
    ApiProperty({ format: 'E.164', minLength: 12, maxLength: 15, example: '+12025550105', description: 'https://en.wikipedia.org/wiki/E.164' }),
    IsOptional({ groups: [UserExposeGroup.SEARCH, UserExposeGroup.PATCH] }),
    IsPhoneNumberWithLVS(undefined, { groups: [UserExposeGroup.CREATE, UserExposeGroup.PATCH] }),
    Expose({
        groups: [
            UserExposeGroup.MODEL,
            UserExposeGroup.READ,
            UserExposeGroup.CREATE,
            UserExposeGroup.SEARCH,
            UserExposeGroup.PATCH,
            UserExposeGroup.SEARCH_RESULT,
        ],
    }),
    __metadata("design:type", String)
], ReadUserProfileDto.prototype, "phone_number", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Date }),
    IsOptional({ groups: [UserExposeGroup.CREATE, UserExposeGroup.PATCH, UserExposeGroup.SEARCH] }),
    IsDate({
        groups: [UserExposeGroup.CREATE, UserExposeGroup.PATCH, UserExposeGroup.CONFIGURABLE, UserExposeGroup.SEARCH],
        message: "Birthday should be a date string in 'yyyy-mm-dd' format",
    }),
    MaxDate(DateTime.local().setZone('utc', { keepLocalTime: true }).minus({ years: 6 }).toJSDate(), {
        groups: [UserExposeGroup.CREATE, UserExposeGroup.PATCH, UserExposeGroup.CONFIGURABLE, UserExposeGroup.SEARCH],
        message: `Max allowed date for birthday is '${DateTime.local().setZone('utc', { keepLocalTime: true }).minus({ years: 6 }).toFormat('yyyy-MM-dd')}'`,
    }),
    TransformWithLVS(({ value }) => {
        if (value && typeof value === 'string' && new RegExp(/^\d{4}-\d{2}-\d{2}/g).test(value)) {
            return DateTime.fromFormat(value.substr(0, 10), 'yyyy-MM-dd').setZone('utc', { keepLocalTime: true }).toJSDate();
        }
        return value;
    }, { groups: [UserExposeGroup.CREATE, UserExposeGroup.PATCH, UserExposeGroup.CONFIGURABLE, UserExposeGroup.SEARCH] }),
    TransformWithLVS(({ value }) => {
        if (value && typeof value === 'string' && new RegExp(/^\d{4}-\d{2}-\d{2}/g).test(value)) {
            return DateTime.fromFormat(value.substr(0, 10), 'yyyy-MM-dd').setZone('utc', { keepLocalTime: true }).toFormat('yyyy-MM-dd');
        }
        if (value && value instanceof Date) {
            return DateTime.fromJSDate(value).setZone('utc', { keepLocalTime: true }).toFormat('yyyy-MM-dd');
        }
        return value;
    }, { groups: [UserExposeGroup.READ, UserExposeGroup.SEARCH_RESULT] }),
    Expose({
        groups: [
            UserExposeGroup.MODEL,
            UserExposeGroup.READ,
            UserExposeGroup.CREATE,
            UserExposeGroup.PATCH,
            UserExposeGroup.SEARCH,
            UserExposeGroup.SEARCH_RESULT,
            UserExposeGroup.CONFIGURABLE,
        ],
    }),
    __metadata("design:type", String)
], ReadUserProfileDto.prototype, "birthday", void 0);
//# sourceMappingURL=ReadUserProfileDto.js.map